import { motion } from "framer-motion";

const ProgressBar = ({ steps, currentStep, bg, h, color }) => {
  const progress = (currentStep / steps) * 100;

  return (
    <motion.div
      className="progress-container"
      style={{
        width: "100%",
        backgroundColor: bg ? bg : "rgba(255, 255, 255, 0.6)",
        borderRadius: "5px",
      }}
    >
      <motion.div
        className="progress-bar"
        style={{
          width: `${progress}%`,
          backgroundColor: color ? color : "#8F8FFF",
          height: h ? h : "4px",
          borderRadius: "10rem",
        }}
        initial={{ width: 0 }}
        animate={{ width: `${progress}%` }}
        transition={{ duration: 0.6 }}
      />
    </motion.div>
  );
};

export default ProgressBar;
